var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"invite-customer-create"},[_c(_vm.componentByStepSlug[_vm.activeStepSlug].component,{tag:"component",on:{"finished":_vm.onFinish}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }